import { render, staticRenderFns } from "./certiFicate.vue?vue&type=template&id=4ef7e50d&scoped=true"
import script from "./certiFicate.vue?vue&type=script&lang=js"
export * from "./certiFicate.vue?vue&type=script&lang=js"
import style0 from "./certiFicate.vue?vue&type=style&index=0&id=4ef7e50d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7e50d",
  null
  
)

export default component.exports